import { Stack, Typography, useTheme } from '@mui/material'
import { DriverContainer, DriverName } from './selected-driver.styles'

interface SelectedDriverProps {
  firstDriverName?: string
  secondDriverName?: string
}

const SelectedDriver = ({
  firstDriverName,
  secondDriverName,
}: SelectedDriverProps) => {
  const theme = useTheme()

  return (
    <Stack direction="row" spacing={4}>
      {firstDriverName?.trim() !== '' && (
        <DriverContainer direction="row" spacing={1}>
          <Typography variant="body2" sx={{ fontSize: '0.875rem', fontWeight: 600 }}>
            Driver Name
          </Typography>
          <DriverName theme={theme}>{firstDriverName}</DriverName>
        </DriverContainer>
      )}

      {secondDriverName?.trim() !== '' && (
        <DriverContainer direction="row" spacing={1}>
          <Typography variant="body2" sx={{ fontSize: '0.875rem', fontWeight: 600 }}>
            Driver Name 2
          </Typography>
          <DriverName theme={theme}>{secondDriverName}</DriverName>
        </DriverContainer>
      )}
    </Stack>
  )
}

export default SelectedDriver
